import clsx from 'clsx';

import BaseComponent from '@tock/shared/components/BaseComponent';
import LoadingComponent from '@tock/shared/components/LoadingComponent';

interface Props {
  isLoading: boolean;
}

export default class ConsumerOverlay extends BaseComponent<Props> {
  render() {
    const { children, isLoading } = this.props;
    const containerClassName = clsx({ ConsumerOverlay: isLoading });

    return (
      <LoadingComponent
        showOverlay={true}
        containerClassName={containerClassName}
        isLoading={isLoading}
        isBallPulse={true}
        spinnerClassName="ConsumerOverlay-spinner"
      >
        {children}
      </LoadingComponent>
    );
  }
}
